// extracted by mini-css-extract-plugin
export default {"scrollSection":"DashboardPage_scrollSection__ER0DA"};